import { io } from 'socket.io-client';
import { SERVICE_HOST } from '../BaseUrl/serviceHost';

export const CHAT_SOCKET_URL = SERVICE_HOST;

export const SOCKET_DEBUG_ENABLED = false; //process.env.NODE_ENV !== 'production';

export const getCurrentCompanyId = () => {
    try {
        const userData = JSON.parse(localStorage.getItem('clinicDetails') || '{}');

        return userData?._id || userData?.company || '';
    } catch {
        return '';
    }
};

export const createChatSocket = (companyId = '') =>
    io(CHAT_SOCKET_URL, {
        withCredentials: true,
        auth: {
            companyId
        },
        transports: ['websocket', 'polling']
    });



export const logSocketEvent = (label, payload) => {
    if (!SOCKET_DEBUG_ENABLED) return;

    if (typeof payload === 'undefined') {
        console.log(`[chat-socket] ${label}`);
        return;
    }

    //   console.log(`[chat-socket] ${label}`, payload);
};

export const joinChatRoom = (socket, chatToken) => {
    if (!socket || !chatToken) return;
    logSocketEvent('joinChat emit', { chatToken });
    socket.emit('joinChat', { chatToken });
};

export const registerCompanyScope = (socket, companyId) => {
    if (!socket || !companyId) return;
    logSocketEvent('registerCompanyScope emit', { companyId });
    socket.emit('registerCompanyScope', { companyId });
};

export const leaveChatRoom = (socket, chatToken) => {
    if (!socket || !chatToken) return;
    logSocketEvent('leaveChat emit', { chatToken });
    socket.emit('leaveChat', { chatToken });
};
